import React, { useState } from "react";
import Box from "@mui/material/Box";
import Title from "../../components/Title";
import ProjectsIcon from "@mui/icons-material/DataSaverOff";
import ButtonLoading from "../../components/ButtonLoading";
import SubTitle from "../../components/SubTitle";
import { avatarContainer, container, content, editIcon, projectContainer, projectContainerHover, projectContent, projectDescription, projectsListContainer, projectTitle, projectTitleContent } from "./Projects.style";
import Loading from "../../components/Loading";
import EmptyState from "../../components/EmptyState";
import DrawerNewProject from "./components/DrawerNewProject";
import EditIcon from '@mui/icons-material/Edit';
import { toast } from "react-toastify";
import { ProjectsTypes } from "../../interfaces/ProjectsTypes";
import { useNavigate } from "react-router-dom";
import Divider from "../../components/Divider";
import { colors } from "../../assets/colors";

interface ProjectsScreenProps {
  loading: boolean;
  projects: ProjectsTypes[];
  reload: () => void;
}
  

export default function ProjectsScreen({
  loading,
  projects,
  reload,
}: ProjectsScreenProps) {

  const [hoveredProject, setHoveredProject] = useState<string | null>(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedProject, setSelectedProject] = useState<ProjectsTypes>({} as ProjectsTypes);

  const closeDrower = (shouldReload?: boolean) => {
    setOpenDrawer(false);
    setSelectedProject({} as ProjectsTypes);

    if (shouldReload) {
      reload();
    }
  };

  const renderAvatar = (project: ProjectsTypes) => {
    return (
      <div style={{ ...avatarContainer, backgroundColor: project.color }}>
        <span style={{ color: colors.white }}>
          {project.title.split(' ')[0][0].toUpperCase()}
          {project.title.split(' ')[1] ? project.title.split(' ')[1][0].toUpperCase() : ''}
        </span>
      </div>
    )
  };
// ...existing code...
  const openDrawerNewProject = () => {
    if (projects.length < 3) {
      setOpenDrawer(true)
    } else {
      toast.error("Você atingiu o limite de projetos. Por favor, exclua um projeto antes de criar um novo.");
    }
  };

  const openDrawerNewProjectEdit = (project: ProjectsTypes) => {
    setSelectedProject(project)
    setOpenDrawer(true)
  };

  let navigate = useNavigate();

  return (
    <div style={container}>
      <div style={content}>
        <Title text="Projetos" icon={<ProjectsIcon color="primary" />} />
        <SubTitle text="Cadastre-se e gerencie seus projetos de casos de testes" />
        <ButtonLoading label="Novo projeto" onClick={openDrawerNewProject} style={{ width: 250, marginTop: 30 }} />
        {loading && <Loading />}
        {!loading && projects.length > 0 && (
          <Box sx={projectsListContainer}>
            <SubTitle text={`${projects.length} projetos cadastrados`} />
            {projects.map((project: ProjectsTypes) => (
              <React.Fragment key={project.project_id}>
                <div
                  style={{ ...projectContainer, ...(hoveredProject === project.project_id ? projectContainerHover : {}) }}
                  onMouseEnter={() => setHoveredProject(project.project_id)}
                  onMouseLeave={() => setHoveredProject(null)}
                >
                  <div
                    onClick={() => navigate(`/projects/${project.project_id}`)}
                    style={projectContent}
                  >
                    {renderAvatar(project)}
                    <div style={projectTitleContent as React.CSSProperties}>
                      <span style={projectTitle}>{project.title} </span>
                      <span style={projectDescription}>{project.suitesSize} Suites | {project.testCasesSize} Casos de Testes</span>
                    </div>
                  </div>
                  <div onClick={() => openDrawerNewProjectEdit(project)}>
                    <EditIcon style={editIcon} />
                  </div>
                </div>
                <Divider />
              </React.Fragment>
            ))}
          </Box>
        )}
        {!loading && projects.length === 0 && (
          <EmptyState text="Nenhum projeto encontrado." style={{ marginTop: 30 }} />
        )}
      </div>
      {openDrawer && (
        <DrawerNewProject
          close={closeDrower}
          selectedProject={selectedProject}
        />
      )}
    </div>
  );
}
